<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2020.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2020-12-24                                                         -
  ----------------------------------------------------------------------------->

<template>
  <b-form-input v-model="filterText" type="text" placeholder="Type to filter"
                @change="handleChange($event)"
                @input="handleInput($event)"></b-form-input>
</template>

<script>
export default {
  name: "yega1-filter-box",
  props: {
    filterFunc: {
      type: Function,
      default: function (row, filter_text, ignore_fields) {
        let filter_values = [''];
        if (filter_text) {
          filter_values = filter_text.split(' ');
        }
        let result = true;
        filter_values.forEach((filter_value) => {
          let filter_value_result = Object.keys(row).filter((key) => {
            return !ignore_fields.includes(key);
          }).some((key) => {
            let val = row[key];
            return toString(val).includes(toString(filter_value));
          });
          if (!filter_value_result) {
            result = false;
          }
        });
        return result;

        function toString(val) {
          let result = '';
          if (!val) {
            return result;
          }
          if (val instanceof Object) {
            result = JSON.stringify(val).toLocaleLowerCase();
          } else {
            result = ('' + val).toLocaleLowerCase();
          }
          return result
        }
      }
    },
    filterIgnoreFields: {
      type: Array,
      default: function () {
        return ['id', 'created_at', 'updated_at'];
      }
    },
    filterKey:{
      type: String,
      default:'filter'
    }
  },
  inject:{
    registerItemsReceiver: 'registerItemsReceiver',
    setFilteredItems: 'setFilteredItems',
  },
  data() {
    return {
      filterText: null,
      items: [],
      timeout: null,
      router_initialized: false
    };
  },
  watch:{
    $route (to, from){
      let from_query = from.query[this.filterKey];
      let to_query = to.query[this.filterKey];
      if(from_query !== to_query){
        this.filterText = to_query;
        this.filterItems();
      }
    }
  },
  created(){
    this.registerItemsReceiver(this);
  },
  mounted(){
    this.initializeFromRouter();
  },
  methods: {
    setItems(items){
      this.items = items;
      this.filterItems();
    },
    filterItems(){
      let results = this.items.filter((i) => {
        return this.filterFunc(i, this.filterText, this.filterIgnoreFields);
      });
      this.setFilteredItems(results);
    },
    handleChange() {
      this.filterItems();
      if(this.router_initialized){
        this.router_initialized = false;
        return;
      }
      if(!!this.filterText && this.filterText !== ''){
        this.setRouter();
      }else{
        this.removeRouter();
      }
    },
    handleInput() {
      if (this.timeout) clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.handleChange();
      }, 300);
    },
    initializeFromRouter(){
      let initialValue = this.$route.query[this.filterKey];
      if(!initialValue) return;
      this.filterText = initialValue;
      this.router_initialized = true;
    },
    setRouter(){
      let route_query = {...this.$route.query}
      route_query[this.filterKey] = this.filterText;
      this.$router.push({ query: route_query });
    },
    removeRouter(){
      let route_query = {...this.$route.query}
      delete route_query[this.filterKey];
      this.$router.push({ query: route_query });
    }
  }
}
</script>

<style scoped>

</style>
